/**
 * Release application entry point.
 */

'use strict';

var app  = require('mag-app'),
    keys = require('stb-keys');


if (  TARGET === 'android-stb' || TARGET === 'android-app' ) {
    window.removeEventListener('keydown', require('spa-app/lib/events').keydown);
    require('../../../helpers/longpress.js')(app, {code: keys.ok, emitCode: keys.menu});
}

require('cjs-polyfills/lib/array.find.index');

// everything is ready
app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language || 'en'}, function () {
        var EpgPage = require('./modules/epg-page/index'),
            epgpage = new EpgPage({
                apiProvider: core.plugins.tvBackend
            });

        app.tvBack = core.plugins.tvBackend;
        app.ui = require('./modules/ui');

        // load pages
        app.pages = {
            main: require('./pages/main'),
            details: require('./pages/details'),
            epg: epgpage
        };

        // add intent handler to show app on incoming intent
        core.addListener('intent', callback => callback(false, {}));

        app.pages.main.addEpgListeners(epgpage);

        // show main page
        app.route(app.pages.main);
    });
});
